module.exports = __webpack_public_path__ + "img/2020-147_Stravenky-logoA-2025-10.106d4c18.png";